export const theme = {
  colors: {
    background: '#faf8f5',
    primary: '#b8973a',
    secondary: '#c07a3a',
    accent: '#2d2d2d',
    text: '#555',
    link: '#8a7040',
    hover: '#a06830',
  },
};
